export default __webpack_public_path__ + "static/khoya-04b6bd0a89752fbd4c6ad2f2d32f3b73.png";